import React from 'react';

const RoadMapCTimelines2022 = () => {
    return ( 
        <div className="section-padding bg-color-body">
				<div className="container">
					<div className="section-heading section-heading--center  col-MB-60">
						{/* <!--<h5 class="__subtitle">NUESTRO CAMINO</h5>--> */}
						<h2 className="__title">Roadmap<br></br>Cardano Timeline 2022</h2>
					</div>

					<div className="row row--xs-middle">
						<div className="col col--md-10">
							{/* <!-- start timeline --> */}
							<div className="timeline timeline--style-2 timeline--dark-color">

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									
									<span className="__text __text--first">
									January 24, 2023
									</span>									
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://cardanoscan.io/transaction/406dc86f8bcc772be28413304f81979d6be33cd9207c87959ab3b7b3756830a9">
									Cardano Timeline 2022 NFT Collection
									</a>
									</h5>
									

									<p>
									Policy ID: 981f0f1026cfa151e4f07b46ff5763a9a1e881094764b21dcd15c5f9
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									January 30, 2023
									</span>

									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://twitter.com/CTimelines_io/status/1620779761101590528">
									Core Team Mint Phase
									</a>
									</h5>

									<p>
									Duration 24hs
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									February 12, 2023
									</span>

									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://twitter.com/CTimelines_io/status/1624874846596341762">
									OG Mint Phase
									</a>
									</h5>

									<p>
									Duration 48hs
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									March 6, 2023
									</span>

									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://twitter.com/CTimelines_io/status/1632718768974581767">
									Whitelist Mint Phase
									</a>
									</h5>

									<p>
									Duration 7 days
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									{/* <span className="__text __text--first">
									March 6, 2023
									</span> */}

									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://twitter.com/CTimelines_io/status/1632718768974581767">
									Public Mint Phase
									</a>
									</h5>

									<p>
									Duration "While supplies last"
									</p>

								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									April 2, 2023
									</span>

									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://twitter.com/CTimelines_io/status/1642558834894839808">
									1st SNAPSHOT
									</a>
									</h5>

									<p>
									Wallets that have collected all 6 NFT Fragments applies
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									April 18, 2023
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://twitter.com/CTimelines_io/status/1648473005834764290">
									1st AIRDROP
									</a>
									</h5>

									<p>
									Cardano Timeline 2022 NFT Airdrop<br></br>
									From unit #50 to #23	 
									</p>
								</div> 
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									September 10, 2023
									</span>

									<h5 className="__text __text--second">
									2nd SNAPSHOT									
									</h5>

									<p>
									Wallets that have collected all 6 NFT Fragments applies	 
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									

									<span className="__text __text--first">
									September 11, 2023
									</span>

									<h5 className="__text __text--second">
									2nd AIRDROP									
									</h5>

									<p>
									Cardano Timeline 2022 NFT Airdrop<br></br>
									From unit #22 to #1
									</p>
								</div>
								{/* <!-- end item --> */}							

								
								
						</div>
					</div>
				</div>
			</div>
        </div>
    )
}

export default RoadMapCTimelines2022;